module.exports = __webpack_public_path__ + "img/xbox.9a5d2e7b.png";